import { ApiUrls } from '@/common/domain/Endpoints.domain';
import instance from '@/common/service/api/Axios';

type TPayload = {
    session_id: string;
};

export type TPaypalResponse = {
    success: boolean;
    data: {
        pp_order_id: string;
        approve_link: string;
    };
    errors: string[];
};

export const fetchPaypalOrder = async (payload: TPayload): Promise<TPaypalResponse> => {
    return instance
        .post<TPaypalResponse>(ApiUrls.checkout.payPal, payload)
        .then(({ data }) => data);
};
